<template>
<section>
    <v-slide-y-transition>
        <div v-show="transitionH">
            <h1 class="text-right text-md-center text-h5 text-md-h2 text-lg-h1 font-weight-black">DETALLE OINK</h1>
            <p class="text-right text-md-center text-p">{{oinkName}}</p>
        </div>
    </v-slide-y-transition>
    <v-slide-y-reverse-transition>
        <v-container v-show="transitionH">
            <v-row justify="center" align="center">
                <v-col cols="12">
                    <actionComp :id="oinkId" />
                </v-col>
                <v-col cols="12">
                    <generalComp :id="oinkId" />
                </v-col>
                <v-col cols="12">
                    <diagramsComp :id="oinkId" />
                </v-col>
            </v-row>
        </v-container>
    </v-slide-y-reverse-transition>
</section>
</template>

<script>
import ActionsComponent from './reports/Actions'
import DiagramsComponent from './reports/Diagrams'
import GeneralComponent from './reports/General'
export default {
    name: 'OinkReports',
    components: {
        'actionComp': ActionsComponent,
        'diagramsComp': DiagramsComponent,
        'generalComp': GeneralComponent
    },
    data() {
        return {
            transitionH: false,
            oinkName: null,
            oinkId: null
        }
    },
    mounted() {
        setTimeout(() => {
            this.transitionH = true
            this.showData = true
        }, 500);
        if (this.$router.history.current.params) {
            this.oinkName = this.$router.history.current.params.name;
            this.oinkId = this.$router.history.current.params.id;
        }
    }
}
</script>
